import React from 'react'

// Placeholder for the rows while a server-sorted refetch is in flight. Borrows
// `.folder-empty-message` so it fills the same slot and the list cannot jump.
const ListLoadingRow = ({ isMobile }) => (
  <div
    className={
      isMobile
        ? 'folder-empty-message folder-empty-message-mobile mx-0 trivvy-list-loading'
        : 'folder-empty-message trivvy-list-loading'
    }>
    <div className="spinner-border spinner-border-sm" role="status">
      <span className="sr-only">Loading</span>
    </div>
  </div>
)

export default ListLoadingRow
